import angular from 'angular';

angular.module('webTools').controller('LogoutCtrl', ['$scope', '$window', 'Reports',
	function($scope, $window, Reports) {

	}
]);
